module.exports = __webpack_public_path__ + "static/media/paleBanner_sm3.399c6943.png";